import React from 'react'

export default function Separator() {
  return (
    <div className="flexbox padding-vertical-medium border-bottom-small border-shade-40" />
  )
}
